import { persist } from '@/assets/js/util.js'

const data = {
    id: null,
    name: '',
    slug: '',
    logo: '',
    primaryColor: '#4CAF50',
    loaded: false,
    posCartId: null,
    plan: 'free',
    subscriptionStatus: 'none',
    customDomain: '',
    line: '',
    whatsapp: '',
    instagram: '',
    address: '',
    addressLink: '',
    categories: []
}

const context = persist('tenant', data)
export default context
